<script setup>
import BackButton from '@/components/shared/buttons/BackButton.vue'
import Heading from '@/components/shared/page/Heading.vue'
import {usePage} from '@/composables/use-page.js'
import {toRefs, watchEffect} from 'vue'

//Emits and props
defineEmits([
  'back',
])
const props = defineProps({
  header: {
    type: String,
    default: '',
  },
  canGoBack: {
    type: Boolean,
    default: false,
  },
})

//Refs and composables
const {header} = toRefs(props)
const {setTitle} = usePage()

//Watch header and set as page title
watchEffect(() => setTitle(header.value))
</script>

<template>
  <div
    v-if="!!header || $slots.header"
    :class="$style.wrapper"
  >
    <slot name="headerLeft">
      <BackButton
        v-if="canGoBack"
        @click="$emit('back', $event)"
      />
    </slot>
    <div :class="$style.header">
      <slot name="header">
        <Heading
          tag="h1"
          :text="header"
        />
      </slot>
    </div>
    <slot name="headerRight" />
  </div>
</template>

<style module>
.wrapper {
  height: var(--navbar-height);
  flex: 0 0 var(--navbar-height);
  margin: 1rem 0;
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0 1.5rem;
  @media (min-width: 768px) {
    padding: 0 2rem;
  }
}
.header {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.heading {
  font-size: var(--font-size-heading-xs);
  font-weight: var(--font-weight-bold);
  line-height: var(--line-height-headings);
  margin: 0;
  @media (min-width: 768px) {
    font-size: var(--font-size-heading-s);
  }
}
</style>
